export const compareConsents = (initialConsents, consents) => {
  let isDifferentFromInitialState = false
  for (const key in initialConsents) {
    if (initialConsents[key] !== consents[key].value) {
      isDifferentFromInitialState = true
    }
  }
  return isDifferentFromInitialState
}

export const RADIO_BUTTONS_IDS = {
  NO_LONGER_INTERESTED: 'noLongerInterested',
  TOO_OFTEN: 'tooOften',
  NOT_WELL_VISUALIZED: 'notWellVisualized',
  OTHERS: 'others'
}

export const PAGE_STATE = {
  DEFAULT: '',
  LOADING: 'loading',
  ERROR: 'error',
  SUCCESS: 'success'
}
